import { generatePath, Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { usePage } from '../../hooks/usePage';
import { workspaceState } from '../../storage/app';
import { PagePermissionName } from '../../types/app';

type Props = {
  children: React.ReactNode;
  redirectPath?: string;
  permissionName: PagePermissionName;
};

export default function PermissionRoute({ children, permissionName, redirectPath = '/' }: Readonly<Props>) {
  const { canAccess } = usePage();
  const selectedWorkspace = useRecoilValue(workspaceState);

  if (!canAccess(permissionName)) {
    return (
      <Navigate
        to={
          redirectPath === '/' || !selectedWorkspace
            ? redirectPath
            : generatePath(redirectPath, { id: selectedWorkspace._id })
        }
        replace
      />
    );
  }

  if (!selectedWorkspace) return null;

  return <>{children}</>;
}
